// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoAnimateController from "./auto_animate_controller"
application.register("auto-animate", AutoAnimateController)

import TimezoneController from "./timezone_controller"
application.register("timezone", TimezoneController)
